import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";

export default function MyAccount() {
  const { user, logout } = useAuth();
  const { tr, lang, setLang, languages } = useLang();
  const nav = useNavigate();

  const doLogout = () => { logout(); nav("/"); };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <div className="pfi-overline">PERSONA FRAGRANCE INTELLIGENCE</div>
        <h1 className="mt-3 font-serif text-3xl sm:text-4xl">{tr("account_title")}</h1>
        <p className="mt-2 text-[#a9a9b8] text-sm">{tr("account_sub")}</p>

        <div className="mt-8 pfi-card p-6 grid sm:grid-cols-2 gap-6">
          <Field label={tr("account_name")} value={user?.name || "—"} testid="account-name" />
          <Field label={tr("account_email")} value={user?.email || "—"} testid="account-email" />
          <div>
            <div className="pfi-overline">{tr("account_language")}</div>
            <div className="mt-3 inline-flex gap-2">
              {languages.map((l) => (
                <button
                  key={l.code}
                  data-testid={`account-lang-${l.code}`}
                  onClick={() => setLang(l.code)}
                  className={
                    "rounded-full px-3 py-1.5 text-xs border transition-colors " +
                    (lang === l.code ? "bg-[#d4af37] text-[#0a0a0c] border-[#d4af37]" : "border-white/10 text-[#a9a9b8] hover:text-[#e6c687]")
                  }
                >
                  {l.short}
                </button>
              ))}
            </div>
          </div>
          <Field label={tr("account_membership")} value="Member" accent testid="account-membership" />
          <Field label={tr("account_ai_access")} value={tr("account_enabled")} accent testid="account-ai-access" />
          <Field label={tr("account_academy_access")} value={tr("account_enabled")} accent testid="account-academy-access" />
        </div>

        <div className="mt-6">
          <button data-testid="account-signout-btn" onClick={doLogout} className="pfi-btn-outline rounded-full px-5 py-2.5 text-sm">
            {tr("nav_signout")}
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Field({ label, value, accent, testid }) {
  return (
    <div data-testid={testid}>
      <div className="pfi-overline">{label}</div>
      <div className={"mt-2 font-serif text-xl " + (accent ? "text-[#e6c687]" : "text-[#f8f8fc]")}>{value}</div>
    </div>
  );
}
